
  var _styles = {
  "coupon-threshold": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "width": "100%"
  },
  "coupon-threshold-text": {
    "width": "100%",
    "color": "rgb(255,45,25)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem",
    "textAlign": "center",
    "textOverflow": "ellipsis",
    "whiteSpace": "nowrap",
    "overflow": "hidden",
    "flex": 1,
    "paddingTop": 0,
    "paddingRight": "0.08rem",
    "paddingBottom": 0,
    "paddingLeft": "0.08rem"
  }
};



  module.exports = _styles;
  